/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
} from '@material-ui/core';

import { formatCurrency } from '../../../../service/utils';

const useStyles = makeStyles({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  container: {
    maxHeight: 400,
    maxWidth: 'calc(100vw - 280px)', 
    overflowX: 'auto',
  },
  table: {
    minWidth: 500,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#303474",
    color: "#fff",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);



const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

export default function TableTop({
  docs,
}) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [monthKeys, setMonthKeys] = useState([]);

  useEffect(() => {
    if (docs && docs.length > 0) {
      const allKeys = new Set();
      docs.forEach(doc => {
        if (doc.months) {
          Object.keys(doc.months).forEach(key => allKeys.add(key));
        }
      });

      const sortedMonths = Array.from(allKeys).sort((a, b) => {
        const [monthA, yearA] = a.split('/');
        const [monthB, yearB] = b.split('/');
        // Criamos objetos de data para compara��o
        return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1);
      });

      setMonthKeys(sortedMonths);
      setRows(docs);
    }
  }, [docs])

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Categoria</StyledTableCell>
              {monthKeys.map((month) => (
                <StyledTableCell key={month} align="right">
                  {month}
                </StyledTableCell>
              ))}
              <StyledTableCell align="right">Valor total</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <StyledTableRow key={row.category}>
                  <StyledTableCell>{row.category}</StyledTableCell>
                  {monthKeys.map((month) => (
                    <StyledTableCell key={month} align="right">
                      {formatCurrency(row.months[month] || 0)}
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {formatCurrency(row.amount)}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
